import {Component} from 'react'
import Loader from 'react-loader-spinner'
import {
  AppContainer,
  LoaderContainer,
  Heading,
  ListOfPackages,
  List,
  ListHead,
  ListText,
  Image,
  ListPara,
} from './styledcomponents'

class TravelGuide extends Component {
  state = {
    packagesList: [],
    isLoading: false,
  }

  componentDidMount() {
    this.getTravelPackages()
  }

  getTravelPackages = async () => {
    this.setState({isLoading: true})
    const apiUrl = 'https://apis.ccbp.in/tg/packages'
    const response = await fetch(apiUrl)
    const data = await response.json()
    const {packages} = data
    const listOfPackages = packages.map(item => ({
      id: item.id,
      name: item.name,
      imageUrl: item.image_url,
      description: item.description,
    }))
    this.setState({
      isLoading: false,
      packagesList: listOfPackages,
    })
  }

  renderLoader = () => (
    <LoaderContainer data-testid="loader">
      <Loader type="TailSpin" color="#00BFFF" height={50} width={50} />
    </LoaderContainer>
  )

  renderTravelGuide = () => {
    const {packagesList} = this.state

    return (
      <>
        <Heading>Travel Guide</Heading>
        <ListOfPackages>
          {packagesList.map(item => (
            <List key={item.id}>
              <Image alt={item.name} src={item.imageUrl} />
              <ListText>
                <ListHead>{item.name}</ListHead>
                <ListPara>{item.description}</ListPara>
              </ListText>
            </List>
          ))}
        </ListOfPackages>
      </>
    )
  }

  render() {
    const {isLoading} = this.state
    return (
      <AppContainer>
        {isLoading ? this.renderLoader() : this.renderTravelGuide()}
      </AppContainer>
    )
  }
}
export default TravelGuide
